(function ($) {
  Drupal.behaviors.gtlSteps = {
    attach: function (context) {
      $('.gtl__steps__content', context).not(':first').hide();

      $('.gtl__steps__header:first', context).addClass('open').attr('aria-expanded', 'true');

      /*            var hash = window.location.hash;
            if (hash) {
                $("a[href='" + hash + "']").addClass('open');
            }
            else {
                $('.gtl__steps__header:first', context).addClass('open');
            };

            console.log(hash);
*/
      $('.js-gtl__step, .js-gtl__step .gtl__steps__header', context).on('click', function (e) {
        e.stopPropagation();
        var drop = $(this).siblings('.gtl__steps__content');

        if (drop.is(':hidden')) {
          $('.open').attr('aria-expanded', $this.attr('aria-expanded') === 'true' ? 'false' : 'true').toggleClass('open').siblings('.gtl__steps__content').hide();
          drop.show();
          drop.find('.product-grid__item:first').find('.product_brief__header').attr('tabindex', '0').focus();
          $(this).toggleClass('open').attr('aria-expanded', $this.attr('aria-expanded') === 'true' ? 'false' : 'true');
        }
      });
    }
  };
})(jQuery);
